import ReactDOM from 'react-dom';
import { useEffect, useState } from "react";
import app from "../components/app";

import {AppLink as Link, AppWrapper, AppBlocks, SelectPages} from "../components/helpers";
import Editor from "./editor";
import Preview from "./preview";
import HeaderJson from "../components/header.json";
import FooterJson from "../components/footer.json";
import {addNewProperty} from "./masterBlocks"
import {submenuColors} from "../components/utility";
import DivKit from "./divKit";
import Plugin from "./plugin";
import HtmlEditor from "./htmlEditor";
import {PreviewIframe} from "./editor";

if(window.location.pathname === "/appmakr/creator-software/build") {
    localStorage.setItem("device", "mobile");
    
}
if(window.location.pathname === "/website/creator-software/build") {
    if(app.isMobile() === "is-mobile") {
        localStorage.setItem("device", "mobile");
    }
    else {
        localStorage.setItem("device", "desktop");
    }
}

const PreviewView = function(props) {
    const [device, setPreviewDevice] = useState(localStorage.getItem("device"));
    // useEffect(() => {
    // }, []);
    const expandFalse = function() {
        if(document.querySelector("body").classList.contains("expand-view")) {
            document.querySelector("body").classList.remove("expand-view");
            props.setAppkitPreview(false);
        }
    }

return <div className='appkit-preview-area'>
        <div className="site-header-new w-100">
        <div className="items-wrap tool-b align-items-center gap-2">

    <div className="device-view-switch d-lg-flex d-none ng-scope">
      <div className="list-item app-tooltip ">
        <a className={`btn ${device === "mobile"?"active":""}`} onClick={() => setPreviewDevice("mobile")}>
          <span className="gi-smartphone">
            <svg className="icon" xmlns="http://www.w3.org/2000/svg" height={24} viewBox="0 -960 960 960" width={24}>
              <path d="M294.648-68.078q-28.354 0-48.269-19.916-19.916-19.916-19.916-48.258v-687.496q0-28.342 19.916-48.258 19.915-19.916 48.269-19.916h370.704q28.354 0 48.269 19.916 19.916 19.916 19.916 48.258v687.496q0 28.342-19.916 48.258-19.915 19.916-48.269 19.916H294.648Zm-12.225-107.576v39.307q0 4.616 3.846 8.462 3.847 3.847 8.463 3.847h370.536q4.616 0 8.463-3.847 3.846-3.846 3.846-8.462v-39.307H282.423Zm0-55.961h395.154v-496.77H282.423v496.77Zm0-552.731h395.154v-39.307q0-4.616-3.846-8.462-3.847-3.847-8.463-3.847H294.732q-4.616 0-8.463 3.847-3.846 3.846-3.846 8.462v39.307Zm0 0V-835.962v51.616Zm0 608.692V-124.038v-51.616Z" />
            </svg>
          </span>
        </a>
    
      </div>
      <div className="list-item app-tooltip">
        <a className={`btn ${device === "desktop"?"active":""}`} onClick={() => setPreviewDevice("desktop")}>
          <span className="gi-desktop">
            <svg className="icon" xmlns="http://www.w3.org/2000/svg" height={24} viewBox="0 -960 960 960" width={24}>
              <path d="M351.04-147.271v-33.768l76.077-76.077h-250.77q-28.437 0-48.353-19.916t-19.916-48.353v-419.076q0-28.437 19.916-48.353 19.916-19.915 48.269-19.915h607.474q28.353 0 48.269 19.915 19.916 19.916 19.916 48.353v419.076q0 28.437-19.916 48.353t-48.353 19.916h-250.77l76.077 76.077v33.768H351.04ZM164.038-397.42h631.924v-347.041q0-4.615-3.847-8.462-3.846-3.846-8.462-3.846H176.347q-4.616 0-8.462 3.846-3.847 3.847-3.847 8.462v347.041Zm0 0v-359.349 359.349Z" />
            </svg>
          </span>
        </a>
       
      </div>
    </div>{/* end ngIf: activeBuildTabForAI=='pageTab30' */}
  </div>
  <div className="items-wrap justify-content-center">
    <div className="web-editor-title text-center">
      <h6 className="m-0 fw-bold">Editor</h6>
      <p className="m-0 ng-binding">Page : Home</p>
    </div>
  </div>


<div className="items-wrap headers-actions">
  <div className="inner-wrapper">
    <div className="item expand-screen-item">
      <div className="expand-screen app-tooltip">
        <a onClick={() => expandFalse()}>
          <span className="material-symbols-rounded">
            <svg className="icon" xmlns="http://www.w3.org/2000/svg" height={24} viewBox="0 -960 960 960" width={24}>
              <path d="M227.5-188.078 188.078-227.5l448.154-448.462H355.654v-55.96h375.96v375.96h-55.96v-280.77L227.5-188.078Z" />
            </svg>
          </span>
        </a>
      
      </div>
    </div>
  </div>
</div>


</div>
<PreviewIframe device={device} />

            </div>
}


function updateIconSize(nextData) { 
    nextData = nextData.map(function(data){
        for (var k in data.elements) { 
            if (data.elements[k].viewType !== "grid") {
                if (data.elements[k]["properties"]) {
                    if(data.elements[k]["properties"]["iconSize"] !== undefined) {
                        data.elements[k]["properties"]["iconSize"] = data.elements[k]["properties"]["iconSize"].toString();
                    }
                    if(data.elements[k]["properties"]["iconSizeWeb"] !== undefined) {
                        data.elements[k]["properties"]["iconSizeWeb"] = data.elements[k]["properties"]["iconSizeWeb"].toString();
                    }
                }
            }
  
            if (data.elements[k]["items"]) {  
                data.elements[k]["items"].forEach(function(val) {
                    for (var key in val) {
                        if (key !== "viewType" && key !== "gridId" && key !== "viewId") {
                            if(val[key]["properties"]) {
                                if(val[key]["properties"].iconSize !== undefined) {
                                    val[key]["properties"].iconSize  = val[key]["properties"].iconSize.toString();
                                }
                                if(val[key]["properties"].iconSizeWeb !== undefined) {
                                    val[key]["properties"].iconSizeWeb  = val[key]["properties"].iconSizeWeb.toString();
                                }
                            }
                        } 
                    } 
                }); 
            }  
        }
        return data;
    })
    return nextData;
} 

function isEmail(email) { 
    return /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(email);
} 

// `pageDataJson` from the getPage endpoint is not always valid JSON. For some
// page types the field is absent entirely, and JSON.parse(undefined) coerces
// its argument to the string "undefined" — hence the reported
// `SyntaxError: "undefined" is not valid JSON`. Parse defensively so a
// malformed or missing payload degrades to the fallback instead of throwing.
const parseJsonSafe = function(raw, fallback){
    if(raw === undefined || raw === null || raw === "" || raw === "undefined" || raw === "null") {
        return fallback;
    }
    if(typeof raw === "object") {
        return raw;                       // already parsed upstream
    }
    try {
        const parsed = JSON.parse(raw);
        return (parsed === undefined || parsed === null) ? fallback : parsed;
    }
    catch(err) {
        console.warn("parseJsonSafe: invalid JSON, using fallback", err);
        return fallback;
    }
};

const openPopup = function(data, callback){
    const div = document.createElement("div");
    document.body.appendChild(div);
    ReactDOM.render(<SelectPages data={data} callback={callback} />, div);
}



export default function Users(props) {
    // console.log("Users---props", props)
    let modeValue = false;
    if(window.location.href.indexOf("localhost:") !== -1) {
        //modeValue  = true;
    }
    const [pages, setPages] = useState([]);
    const [data, setData] = useState(null);
    const [mode, setMode] = useState(modeValue);
    const [device, setPreviewDevice] = useState(localStorage.getItem("device"));
    const [divkitMode, setDivkitMode] = useState(null);
    const [divkitData, setDivkitData] = useState(null);
    const [appkitPreview, setAppkitPreview] = useState(false);
    
    //console.log("Users-data", data)
    useEffect(() => {
        //window.setExpand = setExpand;
        window.setDivkitMode2 = function(mode){
            if(mode) {
                setDivkitMode2(mode);
            }
            else {
                if(document.querySelector("#ai-editor")) {
                    document.querySelector("#ai-editor").classList.remove("popup-view")
                }
                setDivkitMode(null);
            }
        }
        window.setPreviewDevice = function(a){
            setPreviewDevice(a);
            localStorage.setItem("device", a);
        };
        
        if(modeValue == false){
            if(window.location.href.indexOf("localhost:") !== -1) {
                localStorage.setItem("aiAppId", "8d2b519e77ee");
                localStorage.setItem("aiPageId", "home_1787574939298_21");
                localStorage.setItem("userEmail", "ravi@appypiellp.com");
                localStorage.setItem("userId", "40");
            }
        }
        app.loadConfig().then(function(){
            reloadApp();
        });
        // window.reloadApp = reloadApp;
        // c96e5920c055 Sumit Live APP
        // e80cbb09e56f Nitin Live APP 
        // if(["7eb9550f5fca","e80cbb09e56f","c96e5920c055", "6904ba1b4c77","67b99e0f6307","8b92311c0861","dd53182152f4","2add7b694cdf","b1a4bb4e03f5","6bfd4a43728c","00fe69f3d1b5","d336ee72a506","5941ce06e209","4231e53de5bc","4662ed53dbaf","c79add822cc5","2c81813bbcee","800c88a973d4","067e5ea7b8a8","720796e25b36"].indexOf(localStorage.getItem("aiAppId")) !== -1){
        //     document.body.classList.add("testingApp")
        // }
        app.testingApp();
    }, []);

    const getAppData = async function(appId) {
        let url = "https://api.appexecutable.com/webservices/manifest-pwa.php";
        if((window.location.host.indexOf("pbodev.info") !== -1) || (window.location.host.indexOf("72snappynormal") !== -1)) {
            url = "https://72snappy.pbodev.info/webservices/manifest-pwa.php"
        } 
        const response = await fetch(url, {
            method:"POST",
            body:JSON.stringify({ method: "getApp", appId, prevVersion: "0" })
        }) 
        const nextResponse =  await response.json(); 
        console.log("nextResponse", nextResponse)
        return nextResponse
    }
 
    const migrationHeader = async function(appId){ 
        let menifestData = await getAppData(appId);
        menifestData = menifestData.appData; 
        const data = HeaderJson.headerAIData[0];

        const keys = [ 
            "appIcon",
            "appName", 
            "headerBarBackgroundColor",
            "headerBarTextColor",
            "headerBarIconColor",
            "headerBarFont",
            "headerBarSize",
            "headerBarTitle",
            "hideSearchOption",
            "headerBarType",
            "nav_header_image_name", 
            "nav_header_ipad_image_name", 
            "customHeaderImage", 
            "primaryButtonBgColor",
            "buttonTextColor",
            "innerNavbarBlurImage",
            "innerNavbarImage",
            "innerNavbarText" 
        ]; 

        let row = {}; 

        if (menifestData) {
            keys.forEach(key => {
                // console.log(`menifestData[${key}]`, menifestData[key]);
                if (menifestData[key] !== undefined) {
                    row[key] = menifestData[key];
                }
            });
        } else {
            console.log("menifestData is undefined or not an object:", menifestData);
        }

        

        // .app-header.smallHeaderBar,.app-footer.smallHeaderBar { font-size: 13px!important;}
        // .app-header.mediumHeaderBar,.app-footer.mediumHeaderBar { font-size: 15px!important;}
        // .app-header.largeHeaderBar,.app-footer.largeHeaderBar { font-size: 17px!important;}
        // .app-header.xlargeHeaderBar,.app-footer.xlargeHeaderBar { font-size: 20px !important;}
        
        let textSize = "14";
        if(row.headerBarSize === "smallHeaderBar"){
            textSize = "13"
        }
        if(row.headerBarSize === "mediumHeaderBar"){
            textSize = "15"
        }
        if(row.headerBarSize === "largeHeaderBar"){
            textSize = "17"
        }
        if(row.headerBarSize === "xlargeHeaderBar"){
            textSize = "20"
        }

        let fontFamily = "";
        if(row.headerBarFont){
            fontFamily = row.headerBarFont.replaceAll("head-","")
        }
        // console.log("row", data, row)

        if(row){ 
            if (data.elements) {
                // console.log("Elements:");
                for (var k in data.elements) {
                    if(data.elements[k].viewType === "navigation"){
                        data.elements[k]["properties"].textColor = row.headerBarTextColor
                        data.elements[k]["properties"].textColorClick = row.headerBarTextColor
                        data.elements[k]["properties"].textColorHover = row.headerBarTextColor
                        data.elements[k]["properties"].textSize = textSize
                        data.elements[k]["properties"].textSizeWeb = textSize
                        data.elements[k]["properties"].fontFamily = fontFamily
                    }
                    if(data.elements[k].viewType === "headerText"){
                        data.elements[k]["properties"].textColor = row.headerBarTextColor
                        data.elements[k]["properties"].textSize = textSize
                        data.elements[k]["properties"].textSizeWeb = textSize
                        data.elements[k]["properties"].fontFamily = fontFamily
                    }
                    
                    if(data.elements[k].viewType === "headerIcons"){
                        data.elements[k]["properties"].iconBackground = "#00000000"
                        data.elements[k]["properties"].iconBackgroundWeb = "#00000000"
                        data.elements[k]["properties"].iconColor = row.headerBarIconColor
                        data.elements[k]["properties"].iconColorWeb = row.headerBarIconColor
                    }
                    if(data.elements[k].viewType === "advanceSocialLinks"){
                        data.elements[k]["properties"].iconBackground = "#00000000"
                        data.elements[k]["properties"].iconColor = row.headerBarIconColor 
                    }
                    if(data.elements[k].viewType === "button"){
                        data.elements[k]["properties"].background = row.primaryButtonBgColor
                        data.elements[k]["properties"].textColor = row.buttonTextColor 
                    }
                    if(data.elements[k].viewType === "logo"){
                        data.elements[k]["properties"].fontFamily = fontFamily 
                        data.elements[k]["properties"].src = row.appIcon
                        data.elements[k].text = row.appName 
                        data.elements[k]["properties"].textColor = row.headerBarTextColor 
                    }
                    if(data.elements[k].viewType === "textHtml"){
                        if(row.headerBarTitle){
                            data.elements[k].text = row.headerBarTitle
                        } 
                        data.elements[k]["properties"].fontFamily = fontFamily
                        data.elements[k]["properties"].textColor = row.headerBarTextColor 
                        data.elements[k]["properties"].textColorWeb = row.headerBarTextColor 
                    }
                    // console.log(k, data.elements[k]);
                }
            }
            
            if (data.settings) {
                // console.log("Settings:");
                let isSearch = false;
                if(row.hideSearchOption === "NO"){
                    isSearch = true;
                }

                let hideHeader = false;
                if(row.headerBarType === "none"){
                    hideHeader = true;
                }

                let isBlurImage = false
                let isImageInnerPage = false
                let isText = false
                if(row.headerBarType === "image"){
                    if(row.innerNavbarBlurImage){
                        isBlurImage = true
                    }
                    if(row.innerNavbarImage){
                        isImageInnerPage = true
                    }
                    if(row.innerNavbarText){
                        isText = true
                    }
                }

                for (var k in data.settings) {
                    data.settings.hideHeader = hideHeader
                    data.settings.isBlurImage = isBlurImage 
                    data.settings.isImageInnerPage = isImageInnerPage 
                    data.settings.isSearch = isSearch
                    data.settings.isText = isText 
                }
            }
            
            if (data.properties) { 
                let backgroundType = "color"
                let background = app.rgbaToHex(row.headerBarBackgroundColor)
                // console.log("row.headerBarBackgroundColor", row.headerBarBackgroundColor, background)
                if(row.headerBarType === "image"){
                    backgroundType = "custom";
                    background = row.nav_header_image_name
                    // background = row.nav_header_ipad_image_name both are same url
                } 

                for (var k in data.properties) {
                    data.properties.background = background;
                    data.properties.backgroundType = backgroundType;
                    data.properties.backgroundWeb = app.rgbaToHex(row.headerBarBackgroundColor);
                    data.properties.backgroundWebType = "color"; 
                }
            }
        }
        migrationImages(localStorage.getItem("aiAppId"));
        return data;
    }
    
    const migrationImages = async function(appId){
        let menifestData = await getAppData(appId);
        // getAppData can resolve to null (or to a payload with no appData), and
        // this function is invoked fire-and-forget with no .catch, so the
        // dereference below surfaced as an unhandled rejection. Nothing here is
        // required for the editor to work — it's a one-off image migration — so
        // bail out quietly.
        if(!menifestData || !menifestData.appData) {
            console.warn("migrationImages: no appData for", appId, "- skipping migration");
            return;
        }
        menifestData = menifestData.appData;

        if (menifestData.customHeaderImage) {
           let {
                header_200_44 = "",
                header_320_44 = "",
                header_375_44 = "",
                header_414_44 = "",
                header_480_44 = "",
                header_750_88 = "",
                header_800_44 = "",
                header_980_88 = "",
                header_1136_88 = "",
                header_1242_132 = "",
                header_1334_88 = "",
                header_2208_132 = "",
                header_640_44 = "",
                header_640_88 = "",
                header_667_44 = "",
                header_720_44 = "",
                header_1280_44 = "",
                header_1536_88 = "",
                header_2048_88 = ""
            } = menifestData.customHeaderImage;
        
            let headerJson = {
                app_header_image_potrait: header_640_88,
                app_header_image_landscape: header_1136_88,
                headersmartphones: [
                    { width: '200', height: '44', image: header_200_44 },
                    { width: '320', height: '44', image: header_320_44 },
                    { width: '375', height: '44', image: header_375_44 },
                    { width: '414', height: '44', image: header_414_44 },
                    { width: '480', height: '44', image: header_480_44 },
                    { width: '750', height: '88', image: header_750_88 },
                    { width: '800', height: '44', image: header_800_44 },
                    { width: '980', height: '88', image: header_980_88 },
                    { width: '1136', height: '88', image: header_1136_88 },
                    { width: '1242', height: '132', image: header_1242_132 },
                    { width: '1334', height: '88', image: header_1334_88 },
                    { width: '2208', height: '132', image: header_2208_132 }
                ],
                headertabletphones: [
                    { width: '640', height: '44', image: header_640_44 },
                    { width: '667', height: '44', image: header_667_44 },
                    { width: '720', height: '44', image: header_720_44 },
                    { width: '1280', height: '44', image: header_1280_44 },
                    { width: '1536', height: '88', image: header_1536_88 },
                    { width: '2048', height: '88', image: header_2048_88 }
                ]
            }; 

           //As per Mk Developer "headerJson": [headerJson] he is easyly save data thatwhy use []
            app.fetchPost({
                "method":"saveHeaderImageFromManifast",
                "appId":localStorage.getItem("aiAppId"),
                "headerJson": [headerJson]
                }).then(function(response){ 
                if(response){
                    console.log(response.msg)
                }  
            }) 
        }
    }

    const migrationFooter = async function(appId){
        console.log("appIdF", appId)
        let menifestData = await getAppData(appId);
        menifestData = menifestData.appData; 
        const data = FooterJson.footerAIData[0];

        const keys = [
            "appIcon",
            "appName",
            "headerBarBackgroundColor",
            "headerBarTextColor",
            "headerBarIconColor",
            "headerBarFont",
            "headerBarSize",
            "headerBarTitle",
            "hideSearchOption",
            "headerBarType"
        ]; 

        let row = {};
        if (menifestData) {
            keys.forEach(key => {
                // console.log(`menifestData[${key}]`, menifestData[key]);
                if (menifestData[key] !== undefined) {
                    row[key] = menifestData[key];
                }
            });
        } else {
            console.log("menifestData is undefined or not an object:", menifestData);
        }

        // console.log("row", row)

        // .app-header.smallHeaderBar,.app-footer.smallHeaderBar { font-size: 13px!important;}
        // .app-header.mediumHeaderBar,.app-footer.mediumHeaderBar { font-size: 15px!important;}
        // .app-header.largeHeaderBar,.app-footer.largeHeaderBar { font-size: 17px!important;}
        // .app-header.xlargeHeaderBar,.app-footer.xlargeHeaderBar { font-size: 20px !important;}
        
        let textSize = "14";
        if(row.headerBarSize === "smallHeaderBar"){
            textSize = "13"
        }
        if(row.headerBarSize === "mediumHeaderBar"){
            textSize = "15"
        }
        if(row.headerBarSize === "largeHeaderBar"){
            textSize = "17"
        }
        if(row.headerBarSize === "xlargeHeaderBar"){
            textSize = "20"
        }

        let fontFamily = "";
        if(row.headerBarFont){
            fontFamily = row.headerBarFont.replaceAll("head-","")
        }

        if(data){  
            if (data.elements) { 
               
                for (var k in data.elements) {
                    if(data.elements[k].viewType === "footerNavigation"){
                        data.elements[k]["properties"].textColor = row.headerBarTextColor
                        data.elements[k]["properties"].textColorClick = row.headerBarTextColor
                        data.elements[k]["properties"].textColorHover = row.headerBarTextColor
                        data.elements[k]["properties"].textSize = textSize
                        data.elements[k]["properties"].textSizeWeb = textSize
                        data.elements[k]["properties"].fontFamily = fontFamily
                    }
                    if(data.elements[k].viewType === "advanceSocialLinks"){
                        data.elements[k]["properties"].iconBackground = "#00000000"
                        data.elements[k]["properties"].iconColor = row.headerBarIconColor 
                    }
                    if(data.elements[k].viewType === "logo"){
                        data.elements[k]["properties"].fontFamily = fontFamily 
                        data.elements[k]["properties"].src = row.appIcon
                        data.elements[k].text = row.appName 
                        data.elements[k]["properties"].textColor = row.headerBarTextColor 
                    }
                    if(data.elements[k].viewType === "textHtml" || data.elements[k].viewType === "contactLinks" || data.elements[k].viewType === "copyRight" || data.elements[k].viewType === "text"){
                        data.elements[k]["properties"].fontFamily = fontFamily
                        data.elements[k]["properties"].textColor = row.headerBarTextColor  
                    }
                    // console.log(k, data.elements[k]);
                }
            }
            
            if (data.properties) { 
                let backgroundType = "color"
                let background = app.rgbaToHex(row.headerBarBackgroundColor)
                 
                for (var k in data.properties) {
                    data.properties.background = background;
                    data.properties.backgroundType = backgroundType; 
                }
            }
        } 
        return data;
    }

    const reloadApp = async function() {
        if(localStorage.getItem("aiAppId")) {
            // console.log(localStorage.getItem("aiPageId"));
            app.preloader(true);
            let isHeader = '';
            let isFooter = '';
            if(localStorage.getItem("aiPageId").indexOf('header_') !== -1){
                isHeader = true
            } 
            if(localStorage.getItem("aiPageId").indexOf('footer_') !== -1){
                isFooter = true
            } 
            if(isHeader){
                const response = await getHeaderFooter("header"); 
                setData({
                    dynamicAIData:[response.headerData]
                });
            }
            else if(isFooter){
                const response = await getHeaderFooter("footer"); 
                setData({
                    dynamicAIData:[response.footerData]
                });
            }
            else{
                const response = await app.fetchPost({
                    method: "getPage",
                    appId: localStorage.getItem("aiAppId"),
                    pageId: localStorage.getItem("aiPageId")
                }, true);
                let dynamicAIData = parseJsonSafe(response.pageDataJson, []);
                let divkitJson = JSON.parse(JSON.stringify(dynamicAIData));
                //console.log("dynamicAIDataLoaded", dynamicAIData)
                // pageDataJson may parse to null / {} / non-array (e.g. for
                // htmlcode_ / plugin pages the backend returns a raw object).
                // Downstream code spreads dynamicAIData, so keep it iterable
                // in EVERY mode — this guard used to sit inside
                // if(app.checkDivkit()), so it never ran on the normal path
                // and the spread below threw "K is not iterable".
                if(!Array.isArray(dynamicAIData)) {
                    dynamicAIData = [];
                }
                
                if(localStorage.getItem("aiAppId") === "b66c4179e2e3") {
                    //icon need to string
                    dynamicAIData = updateIconSize(dynamicAIData);
                }
                const data = await getHeaderFooter();
                if(app.checkDivkit()) {
                    if(divkitMode) {
if(divkitMode === "header") {
                        setDivkitData({
                        id: response._id,
                        dynamicAIData: [data.headerData, {
                            data:divkitJson.webJson,
                            mode:divkitMode,
                            "viewId": "viewId_352472387",
                            "viewType": "view",
                            "widgetType": "divkitRender"
                        }].filter(function(v){
                            if(v) {
                                return true;
                            } 
                            return false;
                        })
                    }); 
                    }
                    else {
                        setDivkitData({
                        id: response._id,
                        dynamicAIData: [{
                            data:divkitJson.webJson,
                            mode:divkitMode,
                            "viewId": "viewId_352472387",
                            "viewType": "view",
                            "widgetType": "divkitRender"
                        }, data.footerData].filter(function(v){
                            if(v) {
                                return true;
                            } 
                            return false;
                        })
                    }); 
                    }
                    }
                    
                    
                }
                else {
                    setData({
                        id: response._id,
                        dynamicAIData: [data.headerData, ...dynamicAIData, data.footerData].filter(function(v){
                            if(v) {
                                return true;
                            } 
                            return false;
                        })
                    }); 
                }
                // app.fetchPost({
                //     method: "getPage",
                //     appId: localStorage.getItem("aiAppId"),
                //     pageId: localStorage.getItem("aiPageId")
                // }).then(async function (response) {
                //     // console.log("response.pageDataJson", response)   
                //     let dynamicAIData = JSON.parse(response.pageDataJson);
                    
                //     // for update new and existing key 

                //     // dynamicAIData = dynamicAIData.map((v) => {
                //     //     console.log(v,"v---dynamicAIData");
                //     //     if(v.widgetType === "website_one"){
                //     //         return addNewProperty(v);
                //     //     }
                //     //     return v;
                //     // })

                //     // end

                //     getHeaderFooter().then(function(data){
                //         setData({
                //             id: response._id,
                //             dynamicAIData: [data.headerData, ...dynamicAIData, data.footerData].filter(function(v){
                //                 if(v) {
                //                     return true;
                //                 } 
                //                 return false;
                //             })
                //         }); 
                //     });
                // });
            }
            setTimeout(function(){
                app.preloader(false);
            }, 1000)
            
    
            app.fetchPost({
                method:"getCustomImage",
                appId:localStorage.getItem("aiAppId")
            }, true).then(function(response){
                if(response.customImgList) {
                    app.userImages(response.customImgList.map(function(v){
                        return {
                            name:v.name,
                            id:v.id
                        };
                   }))
                }
            })

            app.fetchPost({
                method:"getFolderFilesFromAws",
                appId:localStorage.getItem("aiAppId")
            }, true).then(function(response){
                if(response.data) {
                    app.userAiImages(response.data.map(function(v){
                        return v;
                    }));
                }
            })
        }
    }

    const setDivkitMode2 = async function(mode) {
        const self = this;
        app.preloader(true);
        const response = await app.fetchPost({
            method: "getPage",
            appId: localStorage.getItem("aiAppId"),
            pageId: localStorage.getItem("aiPageId")
        }, true);

        const responseHF = await getHeaderFooter(mode);

        if(document.querySelector("#ai-editor")) {
            document.querySelector("#ai-editor").classList.add("popup-view")
        }
        

        if(mode === "header") {
            const data = {
                    dynamicAIData:[
                    responseHF.headerData,
                    {
                                data:parseJsonSafe(response.pageDataJson, {}).webJson,
                                mode:mode,
                                "viewId": "viewId_352472387",
                                "viewType": "view",
                                "widgetType": "divkitRender"
                            }
                ]
                }
                setDivkitData(data)
               setDivkitMode(mode);
               app.preloader(false);
        }
        else {
             const data = {
                    dynamicAIData:[
                   
                    {
                                data:parseJsonSafe(response.pageDataJson, {}).webJson,
                                mode:mode,
                                "viewId": "viewId_352472387",
                                "viewType": "view",
                                "widgetType": "divkitRender"
                            },
                            responseHF.footerData
                ]
                }
                   setDivkitData(data)
               setDivkitMode(mode);
               app.preloader(false);
        }
    }

    const savePage = function(data) {
        // console.log("savePage")
        // console.log("data.dynamicAIData", data.dynamicAIData)
        // return false
        let isHeader = '';
        let isFooter = '';
        if(localStorage.getItem("aiPageId") && localStorage.getItem("aiPageId").indexOf('header_') !== -1){
            isHeader = true
        } 
        if(localStorage.getItem("aiPageId") && localStorage.getItem("aiPageId").indexOf('footer_') !== -1){
            isFooter = true
        }
        if(divkitMode === "header") {
            isHeader = true;
        }
         if(divkitMode === "footer") {
            isFooter = true;
        }

        if(isHeader){
            if(data.dynamicAIData[0].widgetType === "headerAi"){
                saveHeader(data.dynamicAIData[0], function(a){
                    console.log(a);
                })
            }
        
        }else if(isFooter){
            const lastIndex = data.dynamicAIData.length - 1; 
            if (data.dynamicAIData[lastIndex].widgetType === "footerAi") {
                saveFooter(data.dynamicAIData[lastIndex], function(a) {
                    console.log(a);
                });
            }
        }
        else{ 

            const promises = []; 
            if (data.dynamicAIData[0].widgetType === "headerAi") {
                const headerPromise = new Promise((resolve, reject) => {
                    saveHeader(data.dynamicAIData[0], function(a) {
                        // console.log(a);
                        resolve(a);
                    });
                });
                promises.push(headerPromise);
            }
         
            const lastIndex = data.dynamicAIData.length - 1;
            if (data.dynamicAIData[lastIndex].widgetType === "footerAi") {
                const footerPromise = new Promise((resolve, reject) => {
                    saveFooter(data.dynamicAIData[lastIndex], function(a) {
                        // console.log(a);
                        resolve(a);
                    });
                });
                promises.push(footerPromise);
            } 
            // console.log("savePage 3")
            const pageDataPromise = app.fetchPost({
                method: "savePageData",
                appId: localStorage.getItem("aiAppId"),
                pageId: localStorage.getItem("aiPageId"),
                id: data.id,
                pageDataJson: JSON.stringify(data.dynamicAIData.filter(function(v) {
                    if (v.widgetType === "headerAi" || v.widgetType === "footerAi") {
                        return false;
                    }
                    return true;
                })),
                userId: "123456",
                publish: 0
            }, true).then(function(response) {
                // console.log(response);
                return response;
            });
        
            if(!app.checkDivkit()) {
                promises.push(pageDataPromise);
            }
            // Execute all the requests in parallel
            Promise.all(promises).then(function(results) {
                console.log('All requests have been completed:', results);
            })
            .catch(function(error) {
                console.error('Error in one or more requests:', error);
            });
        } 
    }

    const publishPage = function(data, callback) {
        let isHeader = '';
        let isFooter = '';
        if(localStorage.getItem("aiPageId") && localStorage.getItem("aiPageId").indexOf('header_') !== -1){
            isHeader = true
        } 
        if(localStorage.getItem("aiPageId") && localStorage.getItem("aiPageId").indexOf('footer_') !== -1){
            isFooter = true
        }  

        if(isHeader){
            if(data.dynamicAIData[0].widgetType === "headerAi"){
                saveHeader(data.dynamicAIData[0], function(a){
                    console.log(a);
                })
            }
        }
        else if(isFooter){
            const lastIndex = data.dynamicAIData.length - 1; 
            if (data.dynamicAIData[lastIndex].widgetType === "footerAi") {
                saveFooter(data.dynamicAIData[lastIndex], function(a) {
                    console.log(a);
                });
            }
        }
        else{
            // console.log("publishPage")
            const promises = []; 
            if (data.dynamicAIData[0].widgetType === "headerAi") {
                const headerPromise = new Promise((resolve, reject) => {
                    saveHeader(data.dynamicAIData[0], function(a) {
                        console.log(a);
                        resolve(a);
                    });
                });
                promises.push(headerPromise);
            }
            
            const lastIndex = data.dynamicAIData.length - 1;
            if (data.dynamicAIData[lastIndex].widgetType === "footerAi") {
                const footerPromise = new Promise((resolve, reject) => {
                    saveFooter(data.dynamicAIData[lastIndex], function(a) {
                        console.log(a);
                        resolve(a);
                    });
                });
                promises.push(footerPromise);
            } 
            
            // console.log("publishPage 3")
            const pageDataPromise = app.fetchPost({
                method: "savePageData",
                appId: localStorage.getItem("aiAppId"),
                pageId: localStorage.getItem("aiPageId"),
                id: data.id,
                pageDataJson: JSON.stringify(data.dynamicAIData.filter(function(v) {
                    if (v.widgetType === "headerAi" || v.widgetType === "footerAi") {
                        return false;
                    }
                    return true;
                })),
                userId: "123456",
                publish: 0
            }, true).then(function(response) {
                console.log(response);
                return response;
            });
        // console.log("promises", promises)
            promises.push(pageDataPromise);
        
            // Execute all the requests in parallel
            Promise.all(promises).then(function(results) {
                console.log('All requests have been completed:', results);
            })
            .catch(function(error) {
                console.error('Error in one or more requests:', error);
            });
        } 
    }
 

const getHeaderFooter = async function(type) {
    let fetchItems = ["getCustomLogo", "getHeader", "getFooter"];
    if(type === "header") {
        fetchItems = ["getCustomLogo", "getHeader"];
    }
    else if(type === "footer") {
        fetchItems = ["getCustomLogo", "getFooter"];
    }
    const values = await Promise.all(fetchItems.map(function(v){
        return app.fetchPost({ method:v, appId:localStorage.getItem("aiAppId"), userId:"123456" }, true);
    }));

    const response = {
        headerData:null,
        footerData:null
    }
    let logo = "";
    if(values[0].data) {
        if(values[0].data.custom_app_icon_image) {
            logo = values[0].data.custom_app_icon_image;
            if(logo.split("/").pop() === "") {
                localStorage.setItem("custom_app_icon_image", "1351667928.png");
            }
            else {
                localStorage.setItem("custom_app_icon_image", logo.split("/").pop());
            }
            //localStorage.setItem("custom_app_icon_image", values[0].data.custom_app_icon_image);
        }
    }
    //values[1].headerData = null;
    //values[2].footerData = null;

    if(type === "header") {
        if(values[1].headerData) {
            let headerData = JSON.parse(values[1].headerData);
            //headerData.elements.logo.properties.src = logo;
            response.headerData = filterHeader(headerData);
            console.log("headerData", headerData)
        }
        else {
            response.headerData = await migrationHeader(localStorage.getItem("aiAppId"));
        }
    }
    else if(type === "footer") {
        if(values[1].footerData) {
            let footerData = JSON.parse(values[1].footerData);
            //footerData.elements.logo.properties.src = logo;
            response.footerData = filterFooter(footerData)
        }
        else {
            response.footerData = await migrationFooter(localStorage.getItem("aiAppId"));
        }
    }
    else {
        if(values[1].headerData) {
            let headerData = JSON.parse(values[1].headerData);
            //headerData.elements.logo.properties.src = logo;
            response.headerData = filterHeader(headerData);
            console.log("headerData", headerData)
        }
        else {
            response.headerData = await migrationHeader(localStorage.getItem("aiAppId"));
        }
        if(values[2].footerData) {
            let footerData = JSON.parse(values[2].footerData);
            //footerData.elements.logo.properties.src = logo;
            response.footerData = filterFooter(footerData)
        }
        else {
            response.footerData = await migrationFooter(localStorage.getItem("aiAppId"));
        }
    }
    return response;
}


    const saveHeader = function(data, callback) {
        app.fetchPost({
            method:"saveHeader",
            appId:localStorage.getItem("aiAppId"), 
            userId:"123456",
            headerJson:JSON.stringify(data),
        }, true).then(function(response){
            callback(response); 
        })
    }

    const filterFooter = function(footerData) {
        if(footerData) {
            if(footerData.elements.copyright) {
                if(footerData.elements.copyright.viewType === "copyRight") {
                    footerData.elements.copyright.viewType = "text";
                }
            }
            if(footerData.elements.logo) {
                if(footerData.elements.logo.properties.showLogo === undefined) {
                    footerData.elements.logo.properties.showLogo = true;
                    footerData.elements.logo.properties.showLogoWeb = true;
                }
                if(footerData.elements.logo.properties.src.indexOf("/1351667928.png") !== -1) {
                    footerData.elements.logo.properties.src = `${app.config().reseller}/media/appicon/1351667928.png`;
                }
            }
            if(!footerData.settings) {
                footerData.settings = {
                    "hideFooter": false
                }
            }
            if(footerData.settings) {
                if(footerData.settings["hideFooterWeb"] === undefined) {
                    footerData.settings["hideFooterWeb"] = false;
                }
            }
            if(localStorage.getItem("isTemplate") === "true") {
                if(footerData.settings.hideFooterWeb === false) {
                    footerData.settings.hideFooterWeb = true;
                }
                if(footerData.settings.hideFooter === false) {
                    footerData.settings.hideFooter = true;
                }
            }
            ["logo", "footerSocialInfo", "footerNavigation"].forEach(function(v){
                if(footerData.elements[v]) {
                    if(footerData.elements[v].properties.textAlignment === undefined) {
                        footerData.elements[v].properties.textAlignment = "center";
                    }
                }
            });
        }
        return footerData;
    }

    const filterHeader = function(headerData) {
        if(headerData) {
            if(headerData.settings.hideHeaderWeb === undefined) {
                headerData.settings.hideHeaderWeb = false;
            }
            if(localStorage.getItem("isTemplate") === "true") {
                if( headerData.settings.hideHeaderWeb === false) {
                    headerData.settings.hideHeaderWeb = true;
                }
                if( headerData.settings.hideHeader === false) {
                    headerData.settings.hideHeader = true;
                }
            }
            //headerData.settings.hideHeader = false;
            //headerData.settings.hideHeaderWeb = false;
            if(headerData.elements.navigation.properties["customMenu"] === undefined) {
                headerData.elements.navigation.properties["customMenu"] = false;
                submenuColors.forEach(function(v){
                    headerData.elements.navigation.properties[v.key] = v.value;
                });
            }
            if(headerData.elements.logo) {
                if(headerData.elements.logo.properties.showLogo === undefined) {
                    headerData.elements.logo.properties.showLogo = true;
                    headerData.elements.logo.properties.showLogoWeb = true;
                }
                if(headerData.elements.logo.properties.src.indexOf("/1351667928.png") !== -1) {
                    headerData.elements.logo.properties.src = `${app.config().reseller}/media/appicon/1351667928.png`;
                }
            }
            if(headerData.elements.headerIcons) {
                if(headerData.elements.headerIcons.icons.cart.showWeb === undefined) {
                    ["cart", "notification", "location"].forEach(function(v){
                        headerData.elements.headerIcons.icons[v].showWeb = true;
                    })
                }
            }
        }
        return headerData;
    }


    const saveFooter = function(data, callback) {
        app.fetchPost({
            method:"saveFooter",
            appId:localStorage.getItem("aiAppId"), 
            userId:"123456",
            footerJson:JSON.stringify(data),
        }, true).then(function(response){
            callback(response); 
        })
    }
 

    // if(expand) {
    //     if(data) {
    //         let iframeStyle = {}
    //         if(device === "mobile") {
    //             iframeStyle = {
    //                 maxWidth:"400px",
    //                 margin:"0px auto",
    //                 display:"block"
    //             }
    //         }
    //         return <iframe id="previewIframe" className="w-100 h-100" style={iframeStyle} src={`https://ai-builder-preview.pages.dev/${device}-preview/${localStorage.getItem("aiAppId")}/${localStorage.getItem("aiPageId")}`} />
    //     }
    // }
    let divkitArea = "";
    if(divkitMode) {
        if(divkitData) {
            divkitArea = <Editor data={divkitData} id={props.page} type="pages" callback={savePage} publishPage={publishPage} getHeaderFooter={getHeaderFooter} setDivkitMode={setDivkitMode} setDivkitData={setDivkitData} />
        }
    }
    
    //console.log("appkitPreview", appkitPreview);
    if(app.checkPlugin()) {
        return <Plugin />
    }
    if(app.checkHtmlEditor()) {
        return <HtmlEditor />
    }
    if(app.checkDivkit()) {
        return <>
        {divkitArea}
        <DivKit getHeaderFooter={getHeaderFooter} setDivkitMode={setDivkitMode} setAppkitPreview={setAppkitPreview} />
        {appkitPreview?<PreviewView setAppkitPreview={setAppkitPreview} />:""}
        </>
    }
    if(modeValue) {
       return <Editor />
    }
    else {
        if(data) {
           return <Editor data={data} id={props.page} type="pages" callback={savePage} publishPage={publishPage} />
        }
        return <div></div>
    }
   
}